/**
 * MSAL Instance Singleton
 *
 * This file creates and exports a single MSAL instance to prevent
 * multiple instances from being created, which can cause authentication issues.
 */

import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, validateAuthConfig } from './authConfig';

// Validate configuration before creating instance
if (!validateAuthConfig()) {
  throw new Error('MSAL configuration validation failed. Please check your environment variables.');
}

// Create the MSAL instance as a singleton
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize the MSAL instance
msalInstance.initialize().catch((error) => {
  console.error('MSAL initialization failed:', error);
});

export default msalInstance;